import seo from './topics.json'
import type { Station } from '../data/stations'

export type Faq = { q: string; a: string }

export type Topic = {
  id: string
  path: string
  nav: string
  title: string
  h1: string
  description: string
  keywords: string[]
  all?: boolean
  artistsFirst?: boolean
  preview?: number
  prefer: string[]
  match: string[]
  paragraphs: string[]
  faqs: Faq[]
}

export const MOOD_IDS = new Set(seo.moodIds)
export const HOME_FAQS: Faq[] = seo.homeFaqs
export const TOPICS = seo.topics as Topic[]

export function getTopic(id: string): Topic | undefined {
  return TOPICS.find((topic) => topic.id === id)
}

export function stationsForTopic(topic: Topic, stations: Station[]): Station[] {
  if (topic.artistsFirst) {
    const artists = stations.filter((station) => !MOOD_IDS.has(station.streamId))
    const moods = stations.filter((station) => MOOD_IDS.has(station.streamId))
    return [...artists, ...moods]
  }
  if (topic.all) return topic.preview ? stations.slice(0, topic.preview) : stations

  const prefer = new Set(topic.prefer)
  const terms = topic.match.map((term) => term.toLowerCase())
  const picked = stations.filter((station) => {
    if (prefer.has(station.streamId) || prefer.has(station.slug)) return true
    const hay = [station.slug, station.name, station.summary, station.description, ...station.keywords]
      .join(' ')
      .toLowerCase()
    return terms.some((term) => hay.includes(term))
  })
  return topic.preview ? picked.slice(0, topic.preview) : picked
}

export function topicsForStation(station: Station): Topic[] {
  return TOPICS.filter((topic) => {
    if (topic.id === 'jewish-music' || topic.id === 'jewish-music-streaming') return true
    if (topic.artistsFirst) return !MOOD_IDS.has(station.streamId)
    return stationsForTopic({ ...topic, preview: undefined }, [station]).length > 0
  })
}
